import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { RestService } from 'src/app/services/rest.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormValidator } from 'src/app/services/form-validator/form-validator';
import * as _ from 'lodash';
import { AmToasterService } from '@angularminds/am-toaster';

@Component({
  selector: 'app-invite-users',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss'],
})
export class InviteUserComponent implements OnInit {
  inviteUsersForm: FormGroup;
  emails: any[] = [];
  isButtonDisabled: boolean = false;
  isSubmitted: boolean;
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private amToasterService: AmToasterService,
    private bsModalRef: BsModalRef,
  ) {}

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.inviteUsersForm = this.fb.group({
      email: ['', [Validators.required, FormValidator.minLength(4), FormValidator.emailsValidator]],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.inviteUsersForm.controls;
  }

  inviteUser() {
    this.isSubmitted = true;
    if (this.inviteUsersForm.invalid) {
      return;
    }
    this.emails = this.inviteUsersForm.controls['email'].value.split(',');
    this.emails = _.filter(this.emails, (email: any) => email);
    if (this.emails.length) {
      this.isButtonDisabled = true;
      const body = {
        emails: this.emails,
      };
      this.restService.post('/api/invite-users/', body).subscribe(
        (response: any) => {
          this.isButtonDisabled = false;
          this.amToasterService.show(
            'success',
            response.message || 'Users invited successfully',
            'Success',
          );
          this.bsModalRef.hide();
        },
        error => {
          this.isButtonDisabled = false;
          this.amToasterService.show('error', error || 'Failed to invite users.', 'Error!');
        },
      );
    }
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
}
